import { useMutation } from '@tanstack/react-query';
import { serializeCoupon } from '../server/serializers';
import useResponseHandler from './useResponseHandler';
import { postAddCoupon } from '../server/requests';
import useOffersData from './useOffersData';

const useAddCoupon = ({ poolId }) => {
    const { extId } = useOffersData();

    const preparePayload = ({
        combinationCount,
        combinationPrice,
        selections,
    }) =>
        serializeCoupon({
            extId,
            poolId,
            combinationPrice,
            combinationCount,
            selections,
        });

    const { handleResponse } = useResponseHandler({
        requestHandler: postAddCoupon,
    });

    const mutationFn = async (params) => {
        const payload = preparePayload(params);
        return await handleResponse(payload);
    };

    const mutation = useMutation(mutationFn);

    return {
        status: mutation,
        addCoupon: mutation.mutateAsync,
    };
};

export default useAddCoupon;
